import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export type PreviewWidgetUniDriver = BaseUniDriver;
